// src/modules/app-views/customers/pages/Init/actions/actionButton.js

import { PlusOutlined, SaveOutlined } from '@ant-design/icons';

const customersDocumentActionButton = () => {
  return {
    action: 'save',
    hideButton: false,
    label: 'save',
    tooltip: 'save_document',
    icon: <SaveOutlined />,
    type: 'primary',
    disabled: false,
    onClick: ({ moduleContext }) => moduleContext?.formContext?.submitForm?.(),
    dropdownItems: [],
  };
};

export default customersDocumentActionButton;
